import axios from 'axios'
import * as utils from 'libs/utils'
import qs from 'qs'
import { getCookie } from 'libs/utils'

const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
    setTimeout(() => reject(TIMEOUT), 10e3)
export default {
    // 新增公司实名认证信息
  companyAuthAdd (params) {
    const url = '/dashboard/user/certification/add'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 个人变更公司认证
  personalToCompany (params) {
    const url = '/dashboard/user/certification/change-to-enterprise'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 普通用户实名认证信息
  commonUserAuthAdd (params) {
    const url = '/dashboard/user/certification/add'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 获取实名认证状态
  getAuthStatus () {
    const url = '/dashboard/user/is-certificated'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 获取实名认证信息
    // 认证方式 authType（1-普通个人 2-在校大学生 3-社会信用代码 *4-营业执照 5-非营利组织 *6-其他认证材料）
    // 4、6 只为兼容老数据
    // 认证类型 type:（1-个人，2-企业，3-创业团队）
  getAuthInfo () {
    const url = '/dashboard/user/certification/get'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  getUpdateAuthInfo () {
    const url = '/dashboard/user/certification/update-get'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 获取变更认证信息    
    getAuthChangeInfo () {
      const url = '/dashboard/user/certification/query-change-status'
      return new Promise((resolve, reject) => {
        axios.get(url)
                  .then(resp => resolve(resp.data))
        timeout(reject)
      })
    },
    // 修改密码
  resetUserMobile (params) {
    const url = '/dashboard/user/secure/change/password'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 获取用户详细信息
  getUserDetailInfo () {
    const url = '/dashboard/user/profile/get'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 修改绑定的手机号
  resetUserMobile (params) {
    const url = '/dashboard/user/secure/bind/mobile'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
    // 修改绑定的邮箱
  resetUserEmail (params) {
    const url = '/dashboard/user/secure/bind/email'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  sentVerCode (type, params) {
    let url = '/dashboard/user/secure/bind/send-mobile-verify-code'
    if (type === 'email') {
      url = '/dashboard/user/secure/bind/send-email-verify-code'
    }
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  resetPwd (params) {
    const url = '/dashboard/user/secure/change/password'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  checkExist (params) {
    const url = '/dashboard/user/check-exist'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  /**
   * 获取用户类型是内部用户还是外部用户：iflybox下线加的
   * @returns {Promise}
   */
  usertypeCssp () {
    const url = '/dashboard/business/cssp/usertype'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  logout (params) {
    const url = '/dashboard/logout'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取修改支付密码的手机或邮箱验证码
  getPayVcode (type, params) {
    let url = '/dashboard/user/secure/update/send-mobile-verify-code'
    if (type === 'email') {
      url = '/dashboard/user/secure/update/send-email-verify-code'
    }
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 验证手机或邮箱验证码
  checkPayVcode (type, params) {
    let url = '/dashboard/user/secure/update/check-mobile-verify-code'
    if (type === 'email') {
      url = '/dashboard/user/secure/update/check-email-verify-code'
    }
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 设置支付密码
  setPayPwd (params) {
    let url = '/dashboard/user/pay-password/set'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  sentChangeCode (params) {
    let url = '/dashboard/user/secure/update/send-mobile-verify-code'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 参数 type 6: 个人实名认证 7:企业认证
  checkChangeCode (params) {
    let url = '/dashboard/user/secure/update/check-mobile-verify-code'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 获取用户学生认证信息（进入学生认证页面就应该先查询一下信息，在做渲染）
  getStudentAuthInfo () {
    let url = '/dashboard/user/certification/student/get'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 进行学生认证
  studentAuthAdd (params) {
    let url = '/dashboard/user/certification/student'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 获取初创团队认证信息
  getSybAuthInfo () {
    let url = '/dashboard/user/certification/entrepreneur/get'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 进行初创团队认证
  sybAuthAdd (params) {
    let url = '/dashboard/user/certification/entrepreneur'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 发送邮箱验证码
  sendEmailCode (params) {
    let url = '/dashboard/user/secure/update/send-email-verify-code'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 发送邮箱验证码
  checkEmailCode (params) {
    let url = '/dashboard/user/secure/update/check-email-verify-code'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 获取公益信息
  isWelfare() {
    let url = Url[Mode].baseUrl +'/herapi/welfare/sign'
    return new Promise((resolve, reject) => {
      utils.jsonpInfo(url, { 'ref': Base64.encode(getCookie('account_id'))}).then(resp => {
        resolve(resp)
      })
      timeout(reject)
    })
  }, 
  // 获取会员信息
  getVip() {
    let url = Url[Mode].baseUrl + '/herapi/welfare/get_vip'
    return new Promise((resolve, reject) => {
      utils.jsonpInfo(url, { 'ref': Base64.encode(getCookie('account_id')) }).then(resp => {
        resolve(resp)
      })
      timeout(reject)
    })
  },
  //获取用户等级
  getLevel(){
    let url = Url[Mode].baseUrl + '/herapi/welfare/get_level'
    return new Promise((resolve, reject) => {
      utils.jsonpInfo(url, { 'ref': Base64.encode(getCookie('account_id')) }).then(resp => {
        resolve(resp)
      })
      timeout(reject)
    })
  },
  // 获取用户是否绑定微信
  getUserWeixinGuide () {
    let url = '/dashboard/wx/bind'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 获取用户微信扫描二维码
  getUserWeixinCode () {
    let url = '/dashboard/wx/code'
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
   // 实名认证变更
  applyChangeCert (params) {
    const url = '/dashboard/user/apply-change-cert'
    return new Promise((resolve, reject) => {
      axios.post(url, params)
                .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取用户实名认证变更信息
  getChangeCert(params){
    let url = '/dashboard/user/get-change-cert?type='+params
    return new Promise((resolve, reject) => {
      axios.get(url)
                .then(resp => { resolve(resp.data) })
                .catch(e => { reject(e) })
      timeout(reject)
    })
  },
  // 获取vip免费领取结果
  getVipResult(params){
    let url = '/dashboard/vip/certification/gift'
    return new Promise((resolve, reject) => {
      axios.post(url)
      .then(resp => { resolve(resp.data) })
      .catch(e => { reject(e) })
      timeout(reject)
    })
  }
}


// WEBPACK FOOTER //
// ./app/api/userauth.js